import React, { Fragment, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Content } from '../../../fgs';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { AllDocuments, DocumentsToApprove } from './subPages';
import { Visible, canView, not } from "../../../fgs/helpers/Authorization";

const FILES_TAB = 'FILES';
const WAITING_APPROVAL_TAB = 'WAITING_APPROVAL';

const ResumedComponent = () => {
  return(
    <AllDocuments />
  );
};

const FullComponent = () => {
  const { hash } = useLocation();
  const initActiveTab = () => {
    return hash === '#waiting-approval' ? WAITING_APPROVAL_TAB : FILES_TAB;
  };

  const [activeTab, setActiveTab] = useState(initActiveTab());

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <Fragment>
      <Nav tabs>
        <NavItem>
          <NavLink
            href="#files"
            active={activeTab === FILES_TAB}
            onClick={() => toggle(FILES_TAB)}>
            Arquivos
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="#waiting-approval"
            active={activeTab === WAITING_APPROVAL_TAB}
            onClick={() => toggle(WAITING_APPROVAL_TAB)}>
            Aguardando Aprovação
          </NavLink>
        </NavItem>
      </Nav>

      <TabContent activeTab={activeTab}>
        <TabPane tabId={FILES_TAB}>
          {activeTab === FILES_TAB ? <AllDocuments /> : null}
        </TabPane>

        <TabPane tabId={WAITING_APPROVAL_TAB}>
          {activeTab === WAITING_APPROVAL_TAB ? <DocumentsToApprove /> : null}
        </TabPane>
      </TabContent>
    </Fragment>
  );
};

export const DocumentListPage = () => {
  return (
    <Content id="nav-item-page">
      <Visible when={canView('DocumentsToApprove')}>
        <FullComponent />
      </Visible>

      <Visible when={not(canView('DocumentsToApprove'))}>
        <ResumedComponent />
      </Visible>
    </Content>
  );
};